import dialog from '@/components/dialog'

export default (Vue)=>{
  Vue.component('jdialog', dialog )
}
